module.exports = __webpack_public_path__ + "img/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-3.2b05f8d5.jpg";